import moment from 'moment';
import 'moment/locale/ja';
import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import { apiKeyCheck, versionGetApi } from "../../../const";
import { setFlightInfo } from "../../../const/RTCC";
import { useRtoaster } from '../../../hooks/useRtoaster';
import common from "../../../resources/RTCC/js/common/common";
import { Button } from "../../atoms/RTCC/button";
import { Label } from '../../atoms/RTCC/label';
import { BreadCrumb } from '../../molecules/RTCC/breadCrumb';
import './../../../resources/RTCC/css/flight/flight.css';
import { FooterContainer } from './footerContainer';

const RtccInputFlightConfirmContainer = (props) => {
    const {
        login,
        toUserInputInfo,
        setToUserInputInfo,
        checkIn,
        checkOut,
        inputFlightInfo,
        setInputFlightInfo
    } = props;

    moment.locale('ja')

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();

    const [linkList, setLinkList] = useState([]);

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        setToUserInputInfo(toUserInputInfo);
        setInputFlightInfo(inputFlightInfo);
        setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/rtcc/reservation", label: "RTCC予約" }, { path: "/reserve/rtcc/inputFlight", label: "フライト情報入力" }]);
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => {
        history.push("/reserve/rtcc/inputFlight", {locationInfo: history.location});
    }
    // 「予約」ボタン押下時
    const onClickReserve = () => {
        let request = {};
        let outInfo = inputFlightInfo.outFlightInfo;
        let inInfo = inputFlightInfo.inFlightInfo;
        if (outInfo && inInfo) {
            request = {
                reserveId: toUserInputInfo.reserveId,
                outFlightInfo: {
                    departureAirportId: outInfo.departureAirportId,
                    arrivalAirportId: outInfo.arrivalAirportId,
                    bordingDate: moment(outInfo.bordingDate.slice(0, -3), "YYYY年MM月DD日").format('YYYY-MM-DD'),
                    bordingTime: outInfo.bordingTime,
                    airlineName: outInfo.airlineName,
                    flightNumber: outInfo.flightNumber
                },
                inFlightInfo: {
                    departureAirportId: inInfo.departureAirportId,
                    arrivalAirportId: inInfo.arrivalAirportId,
                    bordingDate: moment(inInfo.bordingDate.slice(0, -3), "YYYY年MM月DD日").format('YYYY-MM-DD'),
                    bordingTime: inInfo.bordingTime,
                    airlineName: inInfo.airlineName,
                    flightNumber: inInfo.flightNumber
                },
                loginId: login.memberCode,
            }
            common.doPost(setFlightInfo, request, afterSetFlightInfo);
        }
    }
    const afterSetFlightInfo = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            history.push("/reserve/rtcc/inputFlightComplete");
        }
    }

    return (
        <div className="userInputInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="入力内容確認"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            <div className="reserveConirmWrapper">
                <div className="reserveContentWrapper">
                    <Label label="ご予約内容" className="reserveConirmTitle2" />
                    <div className="reservationContentsWrap">
                        <div className="reservationContents">
                            <Label
                                label="ご利用日程"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.startDate + "\n" + "～" + "\n" + toUserInputInfo.endDate}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="施設名"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.hotelName}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="お部屋タイプ"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.roomType }
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="予約番号"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.reserveId}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="guestInfoWrapper">
                <div className="flightInfoWrap">
                    <div className="guestIndexLabelWrapper">
                        <Label
                            label={"行き"}
                            className="reserveConirmTitle"
                        />
                    </div>
                    <div className="userInputConfirmWrapper">
                        <div className="userInputConfirm">
                            <ul style={isWideTablet ? styles.ulStyleSp : styles.ulStyle}>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle}>
                                    <Label
                                        className="inputTitleLabel"
                                        label={"出発地"}
                                    />
                                </li>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle2}>
                                    <Label
                                        label={inputFlightInfo.outFlightInfo ? inputFlightInfo.outFlightInfo.departureAirportName : ""}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div className="userInputConfirm">
                            <ul style={isWideTablet ? styles.ulStyleSp : styles.ulStyle}>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle}>
                                    <Label
                                        className="inputTitleLabel"
                                        label={"到着地"}
                                    />
                                </li>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle2}>
                                    <Label
                                        label={inputFlightInfo.outFlightInfo ? inputFlightInfo.outFlightInfo.arrivalAirportName : ""}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div className="userInputConfirm">
                            <ul style={isWideTablet ? styles.ulStyleSp : styles.ulStyle}>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle}>
                                    <Label
                                        className="inputTitleLabel"
                                        label={"搭乗日"}
                                    />
                                </li>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle2}>
                                    <Label
                                        label={inputFlightInfo.outFlightInfo ? inputFlightInfo.outFlightInfo.bordingDate : ""}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div className="userInputConfirm">
                            <ul style={isWideTablet ? styles.ulStyleSp : styles.ulStyle}>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle}>
                                    <Label
                                        className="inputTitleLabel"
                                        label={"出発時間"}
                                    />
                                </li>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle2}>
                                    <Label
                                        label={inputFlightInfo.outFlightInfo ?
                                            inputFlightInfo.outFlightInfo.bordingTime.slice(0, 2) + "時" +
                                            inputFlightInfo.outFlightInfo.bordingTime.slice(-2) + "分" : ""}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div className="userInputConfirm">
                            <ul style={isWideTablet ? styles.ulStyleSp : styles.ulStyle}>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle}>
                                    <Label
                                        className="inputTitleLabel"
                                        label={"航空会社/便名"}
                                    />
                                </li>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle2}>
                                    <Label
                                        label={inputFlightInfo.outFlightInfo ? (inputFlightInfo.outFlightInfo.airlineName ? inputFlightInfo.outFlightInfo.airlineName : "")
                                            + "/" + (inputFlightInfo.outFlightInfo.flightNumber ? inputFlightInfo.outFlightInfo.flightNumber : "") : ""}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
            <div className="flightInfoWrap2">
                <div className="flightInfoWrap">
                    <div className="guestIndexLabelWrapper">
                        <Label
                            label={"帰り"}
                            className="reserveConirmTitle"
                        />
                    </div>
                    <div className="userInputConfirmWrapper">
                        <div className="userInputConfirm">
                            <ul style={isWideTablet ? styles.ulStyleSp : styles.ulStyle}>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle}>
                                    <Label
                                        className="inputTitleLabel"
                                        label={"出発地"}
                                    />
                                </li>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle2}>
                                    <Label
                                        label={inputFlightInfo.inFlightInfo ? inputFlightInfo.inFlightInfo.departureAirportName : ""}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div className="userInputConfirm">
                            <ul style={isWideTablet ? styles.ulStyleSp : styles.ulStyle}>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle}>
                                    <Label
                                        className="inputTitleLabel"
                                        label={"到着地"}
                                    />
                                </li>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle2}>
                                    <Label
                                        label={inputFlightInfo.inFlightInfo ? inputFlightInfo.inFlightInfo.arrivalAirportName : ""}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div className="userInputConfirm">
                            <ul style={isWideTablet ? styles.ulStyleSp : styles.ulStyle}>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle}>
                                    <Label
                                        className="inputTitleLabel"
                                        label={"搭乗日"}
                                    />
                                </li>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle2}>
                                    <Label
                                        label={inputFlightInfo.inFlightInfo ? inputFlightInfo.inFlightInfo.bordingDate : ""}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div className="userInputConfirm">
                            <ul style={isWideTablet ? styles.ulStyleSp : styles.ulStyle}>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle}>
                                    <Label
                                        className="inputTitleLabel"
                                        label={"出発時間"}
                                    />
                                </li>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle2}>
                                    <Label
                                        label={inputFlightInfo.inFlightInfo ?
                                            inputFlightInfo.inFlightInfo.bordingTime.slice(0, 2) + "時" +
                                            inputFlightInfo.inFlightInfo.bordingTime.slice(-2) + "分" : ""}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div className="userInputConfirm">
                            <ul style={isWideTablet ? styles.ulStyleSp : styles.ulStyle}>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle}>
                                    <Label
                                        className="inputTitleLabel"
                                        label={"航空会社/便名"}
                                    />
                                </li>
                                <li style={isWideTablet ? styles.liStyleSp : styles.liStyle2}>
                                    <Label
                                        label={inputFlightInfo.inFlightInfo ? (inputFlightInfo.inFlightInfo.airlineName ? inputFlightInfo.inFlightInfo.airlineName : "")
                                            + "/" + (inputFlightInfo.inFlightInfo.flightNumber ? inputFlightInfo.inFlightInfo.flightNumber : "") : ""}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="btnToConfirmWrapper">
                <div className="confirmboxWrap">
                    <Button buttonText="戻る" className="btnBack" onClick={onClickBack} buttonClassName="serachBtnText" />
                    <Button buttonText="この内容で登録する" className="btnReserve" onClick={onClickReserve} buttonClassName="serachBtnText" />
                </div>
                <div className="flightToTop">
                    <Link to={"/reserve/rtcc/reservation"} style={styles.bottomLink}>RTCC検索TOPへ戻る</Link>
                </div>
            </div>
            <div style={styles.footer}>
                <FooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        group: state.group,
        room: state.room,
        human: state.human,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login: state.login,
        kaiinken: state.kaiinken,
        area: state.area,
        country: state.country,
        city: state.city,
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        toUserInputInfo: state.toUserInputInfo,
        inputFlightInfo: state.inputFlightInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        },
        setArea: (item) => {
            dispatch({ type: "AREA", payload: { area: item } })
        },
        setCountry: (item) => {
            dispatch({ type: "COUNTRY", payload: { country: item } })
        },
        setCity: (item) => {
            dispatch({ type: "CITY", payload: { city: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
        setInputFlightInfo: (item) => {
            dispatch({ type: "INPUT_FLIGHT_INFO", payload: { inputFlightInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RtccInputFlightConfirmContainer);

const styles = {
    firstRoomWrapper: {
        width: "80%",
        margin: "0px auto",
        backgroundColor: "#808080",
        padding: "10px 10% 10px 10%",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    roomNum: {
        display: "flex",
        padding: "20px 0px 20px 0px",
        marginBottom: "20px",
        justifyContent: "space-between",
        borderBottom: "1px solid #bfbec5",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLinkArea: {
        marginTop: "30px",
        paddingTop: "40px",
        textAlign: "center",
        borderTop: "1px solid rgb(204, 204, 204);",
    },
    bottomLink: {
        padding: "3px",
        color: "black",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    footer: {
        width: "80%",
        padding: "30px 10% 10px 10%",
        whiteSpace: "nowrap",
        color: "white",
        fontWeight: "300",
    },
    genderWrap: {
        marginBottom: "20px",
    },
    gender: {
        display: "flex",
    },
    genderLabel: {
        margin: "0px 30px 0px 10px",
    },
    confirmbox: {
        width: "100%",
        display: "flex",
        borderTop: "1px solid rgb(191, 190, 197)",
        borderBotttom: "1px solid rgb(191, 190, 197)",
        padding: "30px 0px",
    },
    paymentOption: {
        display: "flex",
        marginTop: "20px",
    },
    fee: {
        display: "flex",
        justifyContent: "space-between",
    },
    pullDownArea: {
        display: "flex",
        alignItems: "center"
    },
    reservationInfo: {
        display: "flex",
        justifyContent: "space-between",
        margin: "20px 60px 20px 100px",
    },
    ulStyle: {
        padding: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        margin: "0px auto 0px auto",
    },
    ulStyleSp: {
        padding: 0,
        width: "100%",
        height: "100%",
        display: "block",
        margin: "0px auto 20px auto",
    },
    ulStyle2: {
        padding: "5px 0px 5px 0px",
        width: "100%",
        height: "100%",
        display: "flex",
        margin: "0px auto 0px auto",
    },
    liStyle: {
        listStyle: "none",
        width: "50%",
        height: "50px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center"
    },
    liStyleSp: {
        listStyle: "none",
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center"
    },
    liStyle2: {
        listStyle: "none",
        width: "50%",
        height: "50px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center"
    },
    liBtnStyle: {
        listStyle: "none",
        width: "50%",
        height: "50px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "right",
        padding: "0px 20px 0px 0px",
    },
}